// https://stackoverflow.com/a/54887331
export const truncate = (
  text: string,
  length: number,
  suffix: string = '...'
) => {
  if (text.length > length) {
    return text.substring(0, length) + suffix;
  } else {
    return text;
  }
};

// https://stackoverflow.com/a/44123450
/**
 * Increments the last integer number in the string. Optionally adds a number to it
 * @param {string} str The string
 * @param {boolean} addIfNoNumber Whether or not it should add a number in case the provided string has no number at the end
 */
export const incrementLast = (str: any, addIfNoNumber?: boolean) => {
  if (str === null || str === undefined)
    throw Error('Argument str should be null or undefined');
  const regex = /[0-9]+$/;
  if (str.match(regex)) {
    return str.replace(regex, (match: string) => {
      return parseInt(match, 10) + 1;
    });
  }
  return addIfNoNumber ? `${str}_1` : str;
};

export const validMediaTypes: any = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogg: 'video/ogg',
};

// https://stackoverflow.com/a/47767860
export const urlMediaFileType = (url: string) => {
  return (
    url
      .split(/#|\?/)[0]
      .split('.')
      .pop() || ''
  )
    .toLowerCase()
    .trim();
};

export const urlMediaType = (url: string) => {
  return (
    validMediaTypes[
      (
        url
          .split(/#|\?/)[0]
          .split('.')
          .pop() || ''
      )
        .toLowerCase()
        .trim()
    ] || null
  );
};
